document.addEventListener('DOMContentLoaded', () => {
    const modal = document.getElementById('modal-obra');
    const modalTitle = modal.querySelector('.modal-title');
    const modalIframe = modal.querySelector('iframe');

    // Função para extrair ID do vídeo do YouTube
    const getYouTubeVideoId = (url) => {
        const match = url.match(/(?:https?:\/{2})?(?:w{3}\.)?youtu(?:be)?\.(?:com|be)(?:\/watch\?v=|\/)([^\s&]+)/);
        return match ? match[1] : null;
    };

    // Função para parar o vídeo
    const stopVideo = () => {
        const iframeSrc = modalIframe.src;
        modalIframe.src = '';
        setTimeout(() => {
            modalIframe.src = iframeSrc;
        }, 100);
    };

    // Função para abrir o modal com o vídeo
    const openVideoModal = (event) => {
        event.preventDefault();
        const link = event.currentTarget;
        const title = link.dataset.title;
        const videoUrl = link.dataset.video;
        
        const videoId = getYouTubeVideoId(videoUrl);
        if (videoId) {
            modalTitle.textContent = title;
            modalIframe.src = `https://www.youtube.com/embed/${videoId}?enablejsapi=1`;
        }
    };

    // Função para limpar o iframe quando o modal fechar
    const cleanupModal = () => {
        stopVideo();
    };

    // Adiciona evento de clique em todos os links de obras
    document.querySelectorAll('.inner-obra a').forEach(link => {
        link.addEventListener('click', openVideoModal);
    });

    // Event Listeners para limpar o iframe quando o modal fechar
    modal.addEventListener('hide.bs.modal', cleanupModal);
    modal.addEventListener('hidden.bs.modal', cleanupModal);
    
    // Adiciona evento de clique no botão fechar
    const closeButton = modal.querySelector('.close');
    closeButton.addEventListener('click', () => {
        cleanupModal();
    });
});